import { Component } from '@angular/core';

@Component({
  selector: 'app-payments-list',
  templateUrl: './payments-list.component.html',
  standalone: false,
})
export class PaymentsListComponent {}
